export { default } from './DetailPortal'
